import axios from 'axios'
import $ from 'jquery'

export const api = () => {

    axios.get('/wp-json/batami/v1/getdata', {})
        .then(res => {
            console.log('tables', res)
        })

    // const forms = document.querySelectorAll('form.login__form')
    // if (forms.length === 0)
    //     return

    const form = document.getElementById('login-form')

    /*const logout = document.querySelectorAll('button.logout')
    if (logout.length === 0)
        return*/

    //const proxy = location.host.includes('local') || location.host.includes('upress') || location.host.includes('vangus') ? 'https://cors-anywhere.herokuapp.com/' : ''//
    const proxy = ''//'https://cors-anywhere.herokuapp.com/'
    const url0 = 'http://api.bat-ami.org.il/api/account/isloggedin'
    const url = '//api.bat-ami.org.il/api/account/logon'
    const url2 = '//api.bat-ami.org.il/Api/Account/LogOff'
    const url3 = '//api.bat-ami.org.il/Api/Account/Register'



    //isloggedin
    $.ajax({
        url: '//api.bat-ami.org.il/api/account/isloggedin',
        type: 'POST',
        xhrFields: { withCredentials: true },
        dataType: 'json',
        success: function (data, textStatus, jqXHR) {
            console.log(data);
            console.log(textStatus);
            console.log(jqXHR);
            if (!!data && !!data.isAuth) {
                $('body').addClass('bat-ami-user-logged-in')
                $('.login-icon').unbind('click')
                $('.login-icon').html(`<a class="user-name" href="http://api.bat-ami.org.il/api/account/details">${data.Name}</a>`)
                $('.login-icon').append('<button class="logout">יציאה מהמערכת</button>')
                $('.logout').click(e => {
                    $.ajax({
                        url: '//api.bat-ami.org.il/api/account/LogOff',
                        type: 'POST',
                        xhrFields: { withCredentials: true }
                    }).done(function (data) {
                        location.reload()
                    });
                })


            }

        } // success
    });

    //LogOn

    form.addEventListener('submit', e => {
        e.preventDefault()

        const fields = {}
        form.querySelectorAll('input').forEach(field => {
            fields[field['name']] = field.value
        })
        console.log('Login Data Sent:', fields)

        $.ajax({
            dataType: "json",
            url: url,
            type: 'POST',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Accept': 'application/json',
                //'Content-Type': 'application/json',
                //'Cache': 'no-cache',
            },
            data: fields,
            success: function (res) {
                if (res.isAuth) {
                    console.log(res)
                    let html = `<h3>שלום ${res.Name}<h3>
                        <h4>התחברת בהצלחה!</h4>
                        <div class="success-route"><a href=${window.location.href}>להמשך גלישה באתר</a>
                        <a href="http://api.bat-ami.org.il/api/account/details">למעבר לאזור האישי</a></div>`
                    form.innerHTML = html
                } else {
                    $(form).append(`<span class="error">אחד או יותר מהנתונים אינם נכונים</span>`)
                }
            },
            error: function (xhr, text, err) {
                console.log('xhr:', xhr)
                console.log('err', err)
                form.innerHTML = `<h3>שגיאה: ${text}<h3>`
            }
        })

    })
    /*logout.forEach(but => {
        but.addEventListener('click', e => {

            $.ajax({
                url: '//api.bat-ami.org.il/api/account/LogOff',
                type: 'POST',
                xhrFields: { withCredentials: true }
            }).done(function (data) {
                location.reload()
            });

        })
    })*/

}
